import Calendar from "@/utils/calendar";

export const columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 50,
        fixed:'left',
        customRender: (text, record, index) => {
            return index + 1
        },
    },
    {
        title: '快递单号',
        dataIndex: 'expressNo',
        key: 'expressNo',
        width: 180,
        fixed:'left',
    },
    {
        title: '采购单号',
        dataIndex: 'purchaseNo',
        key: 'purchaseNo',
    },
    // {
    //     title: '商品图片',
    //     dataIndex: 'productImg',
    //     key: 'productImg',
    //     scopedSlots: {
    //         customRender: 'productImgAction'
    //     }
    // },
    {
        title: '订单来源',
        dataIndex: 'systemSource',
        key: 'systemSource',
        customRender: (text, record, index) => {
            return {1: 'D2C', 2: 'B2B'}[text]
        },
    },
    {
        title: '重量',
        dataIndex: 'weight',
        key: 'weight',
        customRender: (text, record, index) => {
            return text/1000 + 'kg'
        },
    },
    {
        title: '箱数',
        dataIndex: 'boxAmount',
        key: 'boxAmount',
    },
    {
        title: '签收时间',
        dataIndex: 'createTime',
        key: 'createTime',
    },
    {
        title: '签收人',
        dataIndex: 'modifierName',
        key: 'modifierName',
    },
    {
        title: '异常提交时间',
        dataIndex: 'flowDate',
        key: 'flowDate',
        customRender: (text, record, index) => {
            return text || '-'
        },
    },
    {
        title: '备注',
        dataIndex: 'remark',
        key: 'remark',
    },
    {
        title: '签收类型',
        dataIndex: 'signType',
        key: 'signType',
        customRender: (text, record, index) => {
            return {0:'未知',1:'采购单签收',2:'仓库调拨签收'}[text] || '异常签收'
        },
    },
    {
        title: '操作',
        key: 'action',
        dataIndex: 'id',
        width: 150,
        fixed:'right',
        scopedSlots: {
            customRender: 'action'
        }
    }
]